import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faChevronRight,
  faDownload
} from "@fortawesome/free-solid-svg-icons";

library.add(faDownload, faChevronRight);


export { FontAwesomeIcon };
